import { render, staticRenderFns } from "./InformationArticle.vue?vue&type=template&id=53c9ba33&scoped=true"
import script from "./InformationArticle.vue?vue&type=script&lang=js"
export * from "./InformationArticle.vue?vue&type=script&lang=js"
import style0 from "./InformationArticle.vue?vue&type=style&index=0&id=53c9ba33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9ba33",
  null
  
)

export default component.exports